import React from "react";

export default function QuotationPreviewSkeleton() {
    return (
        <div className="container qpContentWrapper">
            <div className="row">

                <div className="col-lg-8">
                    <div className="qpPlanSection">
                        <div className="skeleton skeleton-title"></div>
                        <div className="skeleton skeleton-text small"></div>

                        <div className="skeleton skeleton-paragraph"></div>
                        <div className="skeleton skeleton-paragraph"></div>
                        <div className="skeleton skeleton-paragraph"></div>
                    </div>
                </div>

                <div className="col-lg-4">
                    <div className="qpQuotationCard">
                        <div className="skeleton skeleton-title"></div>

                        <div className="skeleton skeleton-text"></div>
                        <div className="skeleton skeleton-text"></div>

                        <div className="skeleton skeleton-price"></div>

                        <div className="skeleton skeleton-button"></div>
                    </div>
                </div>

            </div>

            <div className="qpOrganizerBox">
                <div className="skeleton skeleton-title"></div>

                <div className="qpOrganizerRow">
                    <div className="skeleton skeleton-avatar"></div>

                    <div>
                        <div className="skeleton skeleton-text"></div>
                        <div className="skeleton skeleton-text small"></div>
                    </div>
                </div>
            </div>
        </div>
    );
}